import { SAVE_ALL_CONTACTS } from "./types"

const contactsReducer = (state, action) => {
	switch(action.type){
		case SAVE_ALL_CONTACTS : {
			if(action.payload){
				console.log(action.payload)
				return action.payload
			}
		}

		return state
	}
}

export default contactsReducer